function shouldAutoOpenCollapsible(el) {
  var isDesktop = window.matchMedia('(min-width: 750px)').matches;
  var openDesktop = el.getAttribute('data-open-desktop') === 'true';
  var openMobile = el.getAttribute('data-open-mobile') === 'true';

  if (isDesktop && openDesktop) return true;
  if (!isDesktop && openMobile) return true;
  return false;
}

function expandCollapsible(button) {
  var content = button.nextElementSibling;
  if (!content) return;

  content.style.display = 'block';
  content.style.opacity = '1';
  content.style.visibility = 'visible';
  content.style.height = 'auto';
  button.classList.add('collapsible__button-active');
  button.setAttribute('aria-expanded', 'true');
}

function collapseCollapsible(button) {
  var content = button.nextElementSibling;
  if (!content) return;

  content.style.display = 'none';
  content.style.opacity = '0';
  content.style.visibility = 'hidden';
  content.style.height = '0';
  button.classList.remove('collapsible__button-active');
  button.setAttribute('aria-expanded', 'false');
}

function initCollapsibleButtons(root) {
  var scope = root && root.querySelectorAll ? root : document;
  var collapsibleButtons = scope.querySelectorAll('.collapsible__button');

  collapsibleButtons.forEach(function (button) {
    if (button.dataset.collapsibleBound === '1') return;
    button.dataset.collapsibleBound = '1';

    if (shouldAutoOpenCollapsible(button)) {
      expandCollapsible(button);
    }

    button.addEventListener('click', function () {
      var content = button.nextElementSibling;
      if (!content) return;

      var isOpen = content.style.display === 'block';

      collapsibleButtons.forEach(function (otherButton) {
        if (otherButton !== button) {
          collapseCollapsible(otherButton);
        }
      });

      if (isOpen) {
        collapseCollapsible(button);
      } else {
        expandCollapsible(button);
      }
    });
  });
}

function refreshAutoOpenCollapsible(root) {
  var scope = root && root.querySelectorAll ? root : document;
  scope.querySelectorAll('.collapsible__button').forEach(function (button) {
    if (shouldAutoOpenCollapsible(button)) {
      expandCollapsible(button);
    }
  });
}

function bootCollapsible(root) {
  initCollapsibleButtons(root || document);
  refreshAutoOpenCollapsible(root || document);
}

document.addEventListener('DOMContentLoaded', function () {
  bootCollapsible(document);
});

document.addEventListener('shopify:section:load', function (event) {
  bootCollapsible(event.target);
});

window.addEventListener('load', function () {
  refreshAutoOpenCollapsible(document);
});

bootCollapsible(document);
